import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { URLS } from './_config';
import PublicRoutes from './_config/publicRoutes';
import PrivateRoutes from './_config/privateRoutes';
// import Login from './pages/login';
import withLazyLoad from './pages/lazyLoad';
const Login = withLazyLoad(() => import('./pages/login'));
const Home = withLazyLoad(() => import('./pages/home'));
const Page404 = withLazyLoad(() => import('./pages/404'));
const Design = withLazyLoad(() => import('./pages/design'));
const Profile = withLazyLoad(() => import('./pages/profile'));
const Registration = withLazyLoad(() => import('./pages/registration'));
const ForgotPassword = withLazyLoad(() => import('./pages/forgotPassword'));
const ResetPassword = withLazyLoad(() => import('./pages/resetPassword'));
const GearBuilderAuth = withLazyLoad(() => import('./pages/gearBuilderAuth'));
const RiddellHome = withLazyLoad(() => import('./pages/riddellHome'));
const MyDesignList = withLazyLoad(() => import('./pages/gallery/MyDesignList'));


function App() {
	return (
		<Router basename={process.env.PUBLIC_URL}>
			
			<div className="App">
				<Routes>
					<Route element={<PublicRoutes />}>
						<Route path={URLS.LOGIN} element={<Login />}></Route>
						<Route path={URLS.REGISTER} element={<Registration />}></Route>
						<Route path={URLS.FORGOT_PASSWORD} element={<ForgotPassword />}></Route>
						<Route path={URLS.RESET_PASSWORD} element={<ResetPassword />}></Route>
					</Route>

					<Route path={URLS.GEAR_BUILDER_AUTH} element={<GearBuilderAuth />}></Route>

					{/* <Route path={URLS.RESET_PASSWORD} element={<ResetPassword />}></Route> */}

					<Route element={<PrivateRoutes />}>
						<Route path={URLS.RIDDELL_HOME} element={<RiddellHome />}></Route>
						<Route path={URLS.HOME} element={<Home />}></Route>
						<Route path={URLS.HOME} element={<Home />}></Route>
						<Route path={URLS.DESIGN} element={<Design />}></Route>
						<Route path={URLS.PROFILE} element={<Profile />}></Route>
						<Route path={URLS.MY_DESIGN} element={<MyDesignList />}></Route>
					</Route>

					<Route path={`*`} element={<Page404 />}></Route>
				</Routes>
			</div>
		</Router>
	);
}

export default App;
